import * as types from './types';

const INITIAL_STATE = {
  report: null,
  loading: false,
  loadError: null,
  selectedSites: [],
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.STATUS_CHANGE_LOADING:
      return { ...state, loading: payload };
    case types.STATUS_CHANGE_LOAD_ERROR:
      return {
        ...state,
        loadError: {
          Title: 'Error',
          Message: payload
            ? payload
            : 'An error has occurred. Please try again',
        },
      };
    case types.STATUS_CHANGE_GET_REPORT:
      return {
        ...state,
        report: payload,
      };
    case types.STATUS_CHANGE_SET_SELECTED_SITES:
      return {
        ...state,
        selectedSites: payload,
      };
    case types.STATUS_CHANGE_CLEAR_ERRORS:
      return {
        ...state,
        loadError: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/statuschange/state/report/reducer.js